// extracted by css-extract-rspack-plugin
export default {"ParametersWidgetContainer":"Wp9KX","allowSticky":"xNzCb","isSticky":"yeRrw","isEmbeddingSdk":"uwuQ5"};